/**
 * 가상번호 설정 시트 ($j.F.Mobile.VnumSheet · BS 타겟)
 *
 * 가상번호 = 소유자 그룹 안에서 장비(g5_cars.vnum) 또는 기사(g5_members.driver_uniqnum)를 부르는 순번.
 * 배차되면 오더에 car_uniqnum 으로 실려 일지·배차 화면의 식별자가 된다.
 *
 * 호출:
 *   $j.Ui.BS.open({ target: '$j.F.Mobile.VnumSheet', fixedHeight: true, data: { onSaved } });
 *     onSaved  저장 성공 후 콜백 (목록을 다시 그려야 하는 화면에서 넘긴다)
 *
 * 쓰는 곳: 서류등록(/m/docs/v1 차량 목록의 번호 알약) · 위치설정(/m/setting/gps 차고지 영역)
 *
 * 예전에는 /m/setting/vnum 페이지를 iframe 으로 띄웠다. 페이지 하나가 BS 전용으로만 존재해
 * 부모의 swalert/Toast 를 parent.* 로 건너 부르고, 스타일도 그 페이지에만 갇혀 있었다.
 * 모듈로 옮기면서 그 페이지·라우트는 삭제했다.
 */
import Util from '../../Common/Util';
export default class VnumSheet {
    constructor() {
        this.target   = 'car';  // 설정 항목 (car:장비 / man:기사)
        this.odr      = 'car';  // 일지 정렬 기준
        this.rows     = [];     // [{drivernum, col, sub, vnum}]
        this.isEdit   = false;  // 번호를 건드렸는지 (저장 시 vlist 전송 여부)
        this.onSaved  = null;
    }

    destroy() {
        $(`#${this.id}`).off();
    }

    init() {
        this.onSaved = this.data?.onSaved || null;
        this.parent?.setTitle?.('가상번호 설정');
        this.draw();
        this.initHandler();
        this.load('car');
    }

    // ─── 렌더링 ──────────────────────────────────

    draw() {
        $(`#${this.id}`).html(`
        <div class="vns">
            <p class="vns-desc">
                가상번호는 장비·기사를 부르는 순번입니다. 일지와 배차 화면이 이 순서로 정렬됩니다.
            </p>

            <div class="vns-field">
                <div class="vns-label">설정 항목</div>
                <div class="vns-seg js-target-seg">
                    <button type="button" class="vns-seg-btn is-on" data-v="car">장비</button>
                    <button type="button" class="vns-seg-btn" data-v="man">기사</button>
                </div>
            </div>

            <div class="vns-list js-list"></div>

            <div class="vns-field">
                <div class="vns-label">일지 정렬 기준</div>
                <div class="vns-seg js-odr-seg">
                    <button type="button" class="vns-seg-btn is-on" data-v="car">장비</button>
                    <button type="button" class="vns-seg-btn" data-v="man">기사</button>
                </div>
            </div>

            <div class="vns-foot">
                <button type="button" class="vns-save js-save">적용하기</button>
            </div>
        </div>`);
    }

    _renderList() {
        const $list = $(`#${this.id}`).find('.js-list');

        if (!this.rows.length) {
            $list.html('<p class="vns-empty">등록된 장비가 없습니다.</p>');
            return;
        }

        // 선택지는 행 수만큼. 목록 밖 번호(예전에 크게 잡아둔 값)는 그 행에만 따로 붙여 살린다.
        const n = this.rows.length;
        const options = (vnum) => {
            let html = '<option value="0">번호</option>';
            let matched = false;
            for (let i = 1; i <= n; i++) {
                const on = String(vnum) === String(i);
                if (on) matched = true;
                html += `<option value="${i}"${on ? ' selected' : ''}>${i}</option>`;
            }
            if (!matched && vnum > 0) html += `<option value="${vnum}" selected>${vnum}</option>`;
            return html;
        };

        $list.html(this.rows.map(r => `
            <div class="vns-row" data-num="${r.drivernum}">
                <div class="vns-row-txt">
                    <span class="vns-row-col">${this._esc(r.col || '-')}</span>
                    ${r.sub ? `<span class="vns-row-sub">${this._esc(r.sub)}</span>` : ''}
                </div>
                <select class="vns-sel js-vnum" data-num="${r.drivernum}">${options(r.vnum)}</select>
            </div>`).join(''));
    }

    // ─── 이벤트 ──────────────────────────────────

    initHandler() {
        const self = this;
        const $el = $(`#${this.id}`);

        // 설정 항목 — 편집 중이면 버리고 바꿀지 먼저 묻는다
        $el.on('click', '.js-target-seg .vns-seg-btn', function () {
            const v = $(this).data('v');
            if (v === self.target) return;
            if (!self.isEdit) { self.load(v); return; }
            Util.swalert(['편집중인 내용이 사라집니다. 그래도 항목을 변경하시겠습니까?', 'question'],
                () => self.load(v), ['네', '아니오']);
        });

        $el.on('click', '.js-odr-seg .vns-seg-btn', function () {
            self.odr = $(this).data('v');
            $el.find('.js-odr-seg .vns-seg-btn').removeClass('is-on');
            $(this).addClass('is-on');
        });

        // 번호 변경 → 모델 갱신 후 번호순으로 다시 그린다.
        //   예전 화면은 "선택값보다 작으면서 가장 가까운 행" 뒤로 DOM 을 옮겼는데,
        //   중복이 생기면 순서가 뒤죽박죽이 됐다. 번호순 정렬이 화면이 약속한 그대로다.
        $el.on('change', '.js-vnum', function () {
            const num  = String($(this).data('num'));
            const vnum = parseInt($(this).val()) || 0;
            const row  = self.rows.find(r => String(r.drivernum) === num);
            if (!row) return;
            row.vnum = vnum;
            self.isEdit = true;
            self.rows.sort((a, b) => (parseInt(a.vnum) || 0) - (parseInt(b.vnum) || 0));
            self._renderList();
            // 방금 바꾼 행을 잠깐 표시해 어디로 갔는지 보이게 한다
            $el.find(`.vns-row[data-num="${num}"]`).addClass('is-moved');
        });

        $el.on('click', '.js-save', () => self.save());
    }

    // ─── 데이터 ──────────────────────────────────

    load(target) {
        const self = this;
        const $el = $(`#${this.id}`);

        $.ajax({
            type: 'GET', url: '/m/ajax/vnum/list', dataType: 'json', data: { t: target },
            success: (res) => {
                if (!res || !res.result) return;
                self.target = res.target;
                self.rows   = res.list || [];
                self.isEdit = false;

                // 정렬기준은 서버 저장값 — 최초 1회만 반영하고 이후엔 유저 선택을 유지한다
                if (!self._odrTouched) { self.odr = res.odr; self._odrTouched = true; }

                $el.find('.js-target-seg .vns-seg-btn').each(function () {
                    $(this).toggleClass('is-on', $(this).data('v') === self.target);
                });
                $el.find('.js-odr-seg .vns-seg-btn').each(function () {
                    $(this).toggleClass('is-on', $(this).data('v') === self.odr);
                });

                self._renderList();
            }
        });
    }

    // 같은 번호를 쓰는 행이 있으면 그 번호들을 돌려준다 (0=미지정은 중복으로 보지 않는다)
    _duplicates() {
        const seen = {}, dup = [];
        this.rows.forEach(r => {
            const v = parseInt(r.vnum) || 0;
            if (!v) return;
            if (seen[v]) { if (dup.indexOf(v) < 0) dup.push(v); }
            seen[v] = true;
        });
        return dup;
    }

    save() {
        const self = this;
        const $el = $(`#${this.id}`);

        const dup = this._duplicates();
        if (dup.length) {
            Util.swalert('중복된 번호가 있습니다.\n번호는 중복될 수 없습니다.', () => {
                self.rows.forEach(r => {
                    if (dup.indexOf(parseInt(r.vnum) || 0) >= 0) {
                        $el.find(`.vns-row[data-num="${r.drivernum}"]`).addClass('is-dup');
                    }
                });
            });
            return;
        }

        Util.swalert(['위와 같이 가상번호를 저장할까요?', 'question'], () => {
            // 번호를 건드리지 않았으면 정렬기준만 저장한다 (서버가 빈 vlist 를 건너뛴다)
            const vlist = self.isEdit
                ? self.rows.map(r => `${r.drivernum}=${parseInt(r.vnum) || 0}`).join(',')
                : '';

            $.ajax({
                type: 'POST', url: '/m/ajax/vnum/save', dataType: 'json',
                data: { t: self.target, odr: self.odr, vlist },
                success: () => {
                    $j.Ui.Toast.show('success', '저장되었습니다.');
                    self.isEdit = false;
                    self.onSaved?.();
                }
            });
        }, ['네', '아니오']);
    }

    _esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c])); }
}
